module.exports = __webpack_public_path__ + "img/about02_en.534b9786.jpg";